export default __webpack_public_path__ + "static/media/arrow-down-primary.14e230b6.svg";